/* eslint-disable class-methods-use-this */
import {
  ComplementaryRes,
  GetComplementaryRes,
  IEducationRes,
  IGetworkexperienceRes,
  ProQualificationsRes,
  SpecialtyRes,
  UserSpecialityRes,
} from "../../models/trainer-registration.model";
import getService from "../getService";
import postService from "../postService";

const CONFIG_API_URL =
  process.env.REACT_APP_API_BASE_URL || "http://20.126.75.78/naptin/api/v1/";
const GETSPECIALITIES = "specialities";
const GETUSERBIO = "user";
const GETUSERSPECIALITIES = "user/specialities";
const GETUSEREDUCATION = "user/educations";
const GETUSERQUAIFICATIONS = "user/proqualifications";
const GETUSEREXPERIENCES = "user/experiences";
const GETUSERCOMPLIMENTARYEXPERIENCE = "user/complementary-experiences";
const GETALLCOMPLEMENTARY = "complementaries";
const PRE_REGISTRATION = "pre-register";
const NATIONALITY = "nationality";
const STATE = "states/";
const LGA = "lgas/";
const CV = "user/cv";

class TrainerRegistrationServices {
  async getUserBio() {
    const response = await getService.get(`${CONFIG_API_URL}${GETUSERBIO}`);

    return response;
  }

  async updateUserBio(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}${GETUSERBIO}`,
      data
    );
    if (response.data.token && response.data.user) {
    }

    return response.data;
  }

  async uploadCv(formData: FormData) {
    const response = await postService.post(`${CONFIG_API_URL}${CV}`, formData);

    return response.data;
  }
  async getCv() {
    const response = await getService.get(`${CONFIG_API_URL}${CV}`);
    return response.data;
  }
  async getUserSpecialty() {
    const response = await getService.get(
      `${CONFIG_API_URL}${GETUSERSPECIALITIES}`
    );
    const data: UserSpecialityRes = response.data;
    return data;
  }
  async getAllComplementary() {
    const response = await getService.get(
      `${CONFIG_API_URL}${GETALLCOMPLEMENTARY}`
    );

    const data: ComplementaryRes = response.data;
    return data;
  }
  async getNationality() {
    const response = await getService.get(`${CONFIG_API_URL}${NATIONALITY}`);

    return response;
  }

  async getState(nationality_id: number) {
    const response = await getService.get(
      `${CONFIG_API_URL}${STATE}${nationality_id}`
    );

    return response;
  }

  async getLga(state_id: number) {
    const response = await getService.get(`${CONFIG_API_URL}${LGA}${state_id}`);

    return response;
  }

  async updateUserSpecialty(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}${GETUSERSPECIALITIES}`,
      data
    );
    if (response.data.token && response.data.user) {
    }
    return response.data;
  }
  async getSpecialties() {
    const response = await getService.get(
      `${CONFIG_API_URL}${GETSPECIALITIES}`
    );
    const data: SpecialtyRes = response.data;
    return data;
  }

  async updateSpecialties(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}${GETSPECIALITIES}`,
      data
    );
    if (response.data.token && response.data.user) {
    }
    return response.data;
  }
  async getUserEducation() {
    const response = await getService.get(
      `${CONFIG_API_URL}${GETUSEREDUCATION}`
    );
    const data: IEducationRes = response.data;
    return data;
  }

  async updateUserEducation(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}${GETUSEREDUCATION}`,
      data
    );
    if (response.data.token && response.data.user) {
    }
    return response.data;
  }
  async getUserQualifications() {
    const response = await getService.get(
      `${CONFIG_API_URL}${GETUSERQUAIFICATIONS}`
    );

    const data: ProQualificationsRes = response.data;
    return data;
  }

  async updateUserQualifications(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}${GETUSERQUAIFICATIONS}`,
      data
    );

    return response.data;
  }
  async getUserExperience() {
    const response = await getService.get(
      `${CONFIG_API_URL}${GETUSEREXPERIENCES}`
    );

    const data: IGetworkexperienceRes = response.data;
    return data;
  }

  async updateUserExperience(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}${GETUSEREXPERIENCES}`,
      data
    );
    return response.data;
  }
  async getUserComplimentaryExperience() {
    const response = await getService.get(
      `${CONFIG_API_URL}${GETUSERCOMPLIMENTARYEXPERIENCE}`
    );

    const data: GetComplementaryRes = response.data;
    return data;
  }

  async updateUserComplimentaryExperience(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}${GETUSERCOMPLIMENTARYEXPERIENCE}`,
      data
    );

    return response.data;
  }

  async preRegistration(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}${PRE_REGISTRATION}`,
      data
    );
    if (response.data.token && response.data.user) {
    }
    return response.data;
  }
  async createHelpRequest(data: any) {
    const response = await postService.post(`${CONFIG_API_URL}help-desk`, data);
    return response.data;
  }

  async getAnnouncements() {
    const response = await getService.get(
      `${CONFIG_API_URL}general-announcements`
    );
    return response.data;
  }
}

export default new TrainerRegistrationServices();
